import { render, staticRenderFns } from "./CPanelDomains.vue?vue&type=template&id=4c7cc0b4&"
import script from "./CPanelDomains.vue?vue&type=script&lang=js&"
export * from "./CPanelDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports